import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { QRCodeWrapperModule } from '../shared/qrcode-wrapper.module';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../core/auth.guard';

import {
  KnowledgeComponent,
  PotencialClientsComponent,
  SurveyComponent,

} from '.';
function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
  }
}


const routes: Routes = [
  { path: 'potencial-clients', component: PotencialClientsComponent, canActivate: [AuthGuard] },
  { path: 'survey', component: SurveyComponent, canActivate: [AuthGuard] },
  { path: 'knowledge', component: KnowledgeComponent, canActivate: [AuthGuard] },
];

const pages = [
  KnowledgeComponent,
  PotencialClientsComponent,
  SurveyComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    QRCodeWrapperModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    ...pages
  ],
  providers: []
})
export class MarketingModule { 
  constructor(@Optional() @SkipSelf() parentModule: MarketingModule) {
    if (parentModule) {
      throw new Error('Module is already loaded. Import in your base AppModule only.');
    }
  }
}
